module.exports = __webpack_public_path__ + "img/clap.1cb343b9.svg";